<template>
    <div  class="allBox">
    <div class="title">
      <strong @click="$router.go(-1)" style="cursor: pointer"
        ><i class="el-icon-back"></i
      ></strong>
      <span>查看活动详情</span>
    </div>
    <!-- <div class="href">
      <div class="item"><span @click="go(133)">活动基础信息</span></div>
      <div class="item"><span @click="go(358)">活动日期</span></div>
      <div class="item"><span @click="go(884)">活动规则</span></div>
    </div> -->
    <div class="scroll">
      <div class="mainBox">
        <div class="card">
          <div class="cardBody">
            <div class="left">
              <img src="../../assets/images/active/download.svg" alt="" />
            </div>
            <div class="right">
              <div class="top">第N份优惠活动介绍</div>
              <div class="bottom">
                提升客单的优惠活动,常用于情侣消费、朋友消费，例：饮品第二杯半价。活动菜品的【做法加价】参与优惠，【加料】和【餐盒】均不参与优惠。
              </div>
            </div>
          </div>
        </div>
        <h3 class="textTitle">活动基础信息</h3> 
        <el-row>
            <el-form label-width="120px">
                <el-col>
                    <el-form-item label="活动名称:" required>
                         <span>李子园第二瓶半价</span>
                    </el-form-item>
                </el-col>
            </el-form>
        </el-row>
        </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.allBox {
  height: 100%;
  background: #fff;
  .title {
    padding: 6px 20px;
    height: 36px;
    border-bottom: 2px solid #f6f6f6;
    display: flex;
    align-items: center;
    span {
      margin-left: 10px;
    }
    i,
    span {
      font-size: 20px;
      font-weight: 500;
    }
  }
  .href {
    display: flex;
    align-items: center;
    height: 48px;
    border-bottom: 1px solid rgb(229, 229, 229);
    overflow: hidden;
    padding-left: 4px;
    // padding: 6px 20px;
    .item {
      padding: 7px 16px;
      overflow: hidden;
      color: rgb(51, 51, 51);
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      span {
        cursor: pointer;
        transition: all 0.3s ease 0s;
      }
      span:hover {
        color: rgb(255, 96, 0);
      }
    }
  }
  .mainBox {
    padding: 24px;
    .card {
      border: 1px solid rgb(232, 232, 232);
      border-radius: 2px;
      transition: all 0.3s ease 0s;
      .cardBody {
        padding: 24px;
        display: flex;
        .left {
          margin-right: 16px;
          img {
            width: 48px;
            height: 48px;
          }
        }
        .right {
          .top {
            margin-bottom: 8px;
            overflow: hidden;
            color: rgb(51, 51, 51);
            font-weight: 500;
            font-size: 16px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .bottom {
            color: rgb(102, 102, 102);
            font-size: 14px;
          }
        }
      }
    }
  }
}
.textTitle {
  position: relative;
  right: 24px;
  padding-left: 24px;
  font-size: 16px;
  line-height: 24px;
  width: max-content;
  border-left: none;
  margin-bottom: 16px;
  margin-top: 16px;
  background-image: linear-gradient(
    270deg,
    rgba(255, 189, 0, 0),
    rgba(255, 202, 0, 0.14) 49%,
    rgba(255, 208, 0, 0.3)
  );
  color: rgb(34, 34, 34);
  font-weight: 500;
  border: none;
}
/deep/ .el-form-item__label{
    color: #000;
}
</style>